import React from 'react';

import {
  Box,
  Tabs,
  Tab,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import Apply from './Apply';
import Notification from './Notification';
import {
  isInitChildApplySelector,
  isInitChildRemoveSelector,
} from './selector';
import { getChildApplyList, getChildRemoveList } from './thunk';

import type { UserAttributes } from '@/infra/cognitoIApi';
import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { FacilityJson } from '@/types/domain/childApply/entities/facilityEntity';

import Title from '@/components/Title';

/**
 * プロパティ
 */
export type Props = {
  /** 子ども */
  child: ChildJson,
  /** ユーザー名 */
  username: string,
  /** 属性 */
  attrs: UserAttributes,
  /** 施設リスト */
  facilityList: FacilityJson[],
};

const ChildApplyList: React.FC<Props> = ({
  child,
  username,
  attrs,
  facilityList,
}) => {
  const tabs = ['申請', '退園通知'];
  const [tabIndex, setTabIndex] = React.useState(0);
  const dispatch = useDispatch();
  const isInitChildApply = useSelector(isInitChildApplySelector);
  const isInitChildRemove = useSelector(isInitChildRemoveSelector);
  React.useEffect(() => {
    if (!isInitChildApply) {
      dispatch(getChildApplyList());
    }
    if (!isInitChildRemove) {
      dispatch(getChildRemoveList());
    }
  }, [dispatch, isInitChildApply, isInitChildRemove]);
  return (
    <div>
      <Title title={`施設申請 - ${tabs[tabIndex]}`} />
      <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '10px' }}>
        <Tabs
          variant="scrollable"
          scrollButtons="auto"
          value={tabIndex}
          onChange={(_event: React.SyntheticEvent, index: number) => {
            setTabIndex(index);
          }}
        >
          {tabs.map((label) => (
            <Tab label={label} key={label} />
          ))}
        </Tabs>
      </Box>
      {tabIndex === 0 && (
        <Apply
          child={child}
          username={username}
          attrs={attrs}
          facilityList={facilityList}
        />
      )}
      {tabIndex === 1 && (
        <Notification />
      )}
    </div>
  );
};

export default ChildApplyList;
